import React, { useEffect } from "react";
import { Pagination } from "antd";

interface IPaginationProps {
  current?: number;
  total?: number;
  pageSize?: number;
  pageSizeOptions?: number[];
  onChange?: (page: number) => void;
  onShowSizeChange?: (current: number, pageSize: number) => void;
}

const Paginations: React.FC<IPaginationProps> = ({
  current = 1,
  total = 20,
  pageSize = 1,
  pageSizeOptions,
  onChange,
  onShowSizeChange,
}) => {
  useEffect(() => {
    // scroll to top
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [current]);

  return (
    <div style={{ marginBottom: "20px" }}>
      <Pagination
        defaultCurrent={1}
        current={current}
        total={total}
        pageSize={pageSize}
        pageSizeOptions={pageSizeOptions}
        onChange={onChange}
        onShowSizeChange={onShowSizeChange}
        showTitle={false}
        showSizeChanger
      />
    </div>
  );
};

export default Paginations;
